import { AddOnsTemplate } from '@/components/add-ons/template';
import { ComponentsHead } from '@/components/head';
import { FC } from 'react';

export const DOWNTOWN_ST_PETE_ST_PETE_PIER_TITLE =
  'Downtown St Pete & St Pete Pier';

export const Head = () => {
  return (
    <ComponentsHead
      title="Charter a Boat to St. Pete Pier & Downtown Waterfront"
      description="Explore downtown St. Petersburg from the water. Cruise past the Pier, dine dockside, and soak up the art, music, and city views aboard a private charter."
      keywords="St. Pete Pier, Downtown St. Pete, Charter Boat, City Tour"
    />
  );
};

const Page: FC = () => {
  return (
    <AddOnsTemplate
      title="Downtown St. Pete & St. Pete Pier Boat Charters"
      subtitle={DOWNTOWN_ST_PETE_ST_PETE_PIER_TITLE}
    ></AddOnsTemplate>
  );
};

export default Page;
